<template>
  <div>
    <v-stepper-step :complete="step > 1" step="1">
      Redeem Promotion
    </v-stepper-step>

    <v-stepper-content step="1">
      <component :is="promoComponent" @service-selected="nextStep">
        Unspecified promo type
      </component>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PromoUpgrade from './PromoUpgrade'

export default {
  name: 'PromoStepOne',
  components: {
    PromoUpgrade,
  },
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['promo']),
    promoComponent () {
      switch (this.promo.type) {
        case 'upgrade':
          return 'promo-upgrade'
        default:
          return `promo-upgrade`
      }
    }
  },
  methods: {
    nextStep (service) {
      this.$emit('service-selected', service)
    }
  }
}
</script>
